<template>
  <div
    class="component"
    :class="block.class"
    @click="Command"
  >
    <div class="icon"><fas icon="exchange-alt" /></div>
    <div class="command">
      <select :value="block.arg[1]" @change="$emit('changeVal', block.id, $event.target.value, 1)">
        <option v-for="nameList in nameList" :key="nameList.id" :value="nameList.id">{{ nameList.name }}</option>
      </select>
      を
      <input type="text" maxlength="20" />にする

  </div>
  </div>
</template>

<script>
export default {
  props: {
    block: Object,
    nameList: Object,
  },
  data() {
    return {
    };
  },
  methods: {
    Command(){
      this.$emit("command", this.block.click);
    },
  },
};
</script>

<style scoped>
.component {
  position: relative;
  min-height: 50px;
  width: 70%;
  height: auto;
  transition: all 0.3s;
  border: gray solid 2px;
  outline: white solid 2px;
  margin: 5px;
  display: flex;
}
.icon{
  min-width: 50px;
  height: 50px;
  background: #64b184;
  font-size: 30px;
  text-align: center;
  color: #fff8ef;
}
</style>
